import * as React from "react";

function SvgLockTexbox() {
    return (
        <svg height='33px' fill="#284672 "
            xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" space="preserve">
            <g>
            <path d="M58.441,42.739H41.809c-2.159,0-4.22,0.4-6.138,1.097V26.749c0-7.762,6.314-14.076,14.076-14.076   s14.076,6.314,14.076,14.076v6.415l2.583,0.005l-2.583,4.663v2.791h6.527V26.749c0-11.361-9.242-20.604-20.604-20.604   s-20.605,9.243-20.605,20.604v21.207c-3.292,3.262-5.333,7.783-5.333,12.783v16.633c0,9.941,8.059,18,18,18h16.633   c9.941,0,18-8.059,18-18V60.739C76.441,50.798,68.383,42.739,58.441,42.739z M50.125,84.04c-8.262,0-14.984-6.722-14.984-14.984   s6.722-14.984,14.984-14.984s14.984,6.722,14.984,14.984S58.387,84.04,50.125,84.04z"></path>
                <path d="M50.125,55.071c-7.711,0-13.984,6.273-13.984,13.984S42.414,83.04,50.125,83.04s13.984-6.273,13.984-13.984   S57.836,55.071,50.125,55.071z M46.837,74.611l2.052-7.054c-0.591-0.398-0.98-1.074-0.98-1.84c0-1.225,0.992-2.217,2.216-2.217   c1.225,0,2.217,0.992,2.217,2.217c0,0.766-0.389,1.442-0.98,1.84l2.052,7.054H46.837z"></path>
            </g>
        </svg>
       
)}
export default SvgLockTexbox;


// WEBPACK FOOTER //
// ./src/iconComponents/locktextboxIcon.js